import { lookAhead } from "./cardPacing";
import { Card, OfferKind } from "./entities";
import type { LevelSim } from "./levelSim";
import { Offer } from "./offer";

/**
 * The Scout's Map (MP-06, a pre-battle supply): the next in-run hands, read ahead. Each is dealt exactly as the sim will
 * deal it — the same hand plan (cardPacing.lookAhead) and the same draws, from a copy of the run's random stream — on
 * the board as it stands now: laying road or building a tower can change what fits, as it changes the pace. Pure: it
 * never moves the run's stream or state, so asking changes no replay and no hash. A rare's rally offers (M36) are dealt
 * outside the pace and are not foreseen.
 */

/** One hand read ahead: its cards (the Upgrade card included), in the order the offer will show them. */
export interface ScoutedHand { readonly cards: readonly Card[] }

/** The next `count` in-run hands that will show (fewer when the pace has fewer within its look-ahead). */
export function scoutHands(sim: LevelSim, count: number): ScoutedHand[] {
  if (count <= 0 || sim.isOver) return [];
  const rng = sim.rng.clone(), out: ScoutedHand[] = [];
  lookAhead(sim, (plan) => {
    if (plan === null) return false;
    const offer = new Offer();
    offer.reset(0, OfferKind.PostWave);
    offer.plan = plan;
    if (sim.generator.fill(offer, sim.road, sim.owned, sim.towerSlots, rng, null) > 0) out.push({ cards: offer.cards });
    return out.length >= count;
  });
  return out;
}

/** The hands a run's Scout's Map shows (none without one). */
export function scoutedHands(sim: LevelSim): ScoutedHand[] { return scoutHands(sim, sim.mods.supplies?.scout ?? 0); }
